import React, { useContext, useState, useEffect} from 'react'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'
import 'C:/apps/ideafy/src/components/styles/MainPageMobile.css'

import Firebase from '../../config/Firebase';
import  {useForm}  from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from "yup";
import { Link ,useHistory } from 'react-router-dom'
import { useGlobalState } from '../../globalState/globalState'
import { v4 as uuidv4 } from 'uuid';

const SignupButton = ()=> {
    const [email, setEmail] = useGlobalState('email');
    const [emailIsWritten, setEmailIsWritten] = useGlobalState('emailIsWritten');
    // const [doc,setDoc] = useState()
    const [emailUsed, setEmailUsed] = useState(false)
    const [currentId, setCurrentId] = useGlobalState('currentId');
    // const [docTwo, setDocTwo] = useGlobalState('doc');
    const verifyData = async (newReference) => {
        let condition 
        await newReference.get().then(( async snapshot => {
            const snap = await snapshot.exists
            console.log('test snap -', snap)
            condition = snap
            console.log("condition", condition)
            
        }))
        console.log('condition of doc --', condition)
        return condition
    }
    
    const history = useHistory()
    const SignupSchema = Yup.object().shape({
        email: Yup.string()
          .email('Invalid email')
          .required('Write your email please')
    });
    let placeHolder = 'Your Email'
    


    const {register, handleSubmit,errors} = useForm({
        resolver: yupResolver(SignupSchema)
      });

    const onSumbit = async (data) => {
            const currId = uuidv4()
            const newReference = await Firebase.firestore().collection(`users/${data.email}/profile`).doc('email')
            let ver = await verifyData(newReference)
            console.log(ver, 'ver')
            if(ver === true){
                console.log('email exists')
        
                setEmailUsed(true)
            }else{
                console.log(data)
                newReference.set({Email: data.email})
                // newReference.set({Email: data.email})
                setEmail(data.email)
                setCurrentId(currId)
                // console.log(currId)
                // console.log(currentId)
                setEmailIsWritten(true)
                history.push("/submit")
            }

    }
    return(
        <div className = 'signupBtn'>
            <div id = 'signupContainer'> 
                <div id = 'leftPart-SingUpButton'>
                    <input type = "text"  placeholder = {placeHolder} name = 'email' ref = {register}/>
                </div>
                <button id = 'rightPart-SignUpButton'  onClick = {handleSubmit(onSumbit)}>sign up</button>
            </div>
            <div>
                <p id = 'errorSignup'>{errors.email ? errors.email?.message: null}{emailUsed ? '  | Email already exists' : null}</p>
            </div>
        </div>
    )
}


export default SignupButton